/**
 * @generated SignedSource<<efe5cb9f53e68c9ebe01df758ba10489>>
 * @relayHash 08dd3bf7f839283b85db00412711ec40
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 08dd3bf7f839283b85db00412711ec40

import { ConcreteRequest } from 'relay-runtime';
export type ShareMedicalRecordInput = {
  appointmentId?: string | null;
  patientId: string;
  userNameToShared: string;
};
export type useShareMedicalRecordMutation$variables = {
  input: ShareMedicalRecordInput;
};
export type useShareMedicalRecordMutation$data = {
  readonly shareMedicalRecord: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useShareMedicalRecordMutation = {
  response: useShareMedicalRecordMutation$data;
  variables: useShareMedicalRecordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useShareMedicalRecordMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ShareMedicalRecordPayload",
        "kind": "LinkedField",
        "name": "shareMedicalRecord",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useShareMedicalRecordMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ShareMedicalRecordPayload",
        "kind": "LinkedField",
        "name": "shareMedicalRecord",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "08dd3bf7f839283b85db00412711ec40",
    "metadata": {},
    "name": "useShareMedicalRecordMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4fa6fe1775281cefcdcd49f24fb717d7";

export default node;
